/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_4_1Inputs */

const en_gc_search_guides_gridcraft_online_sections_3_table_rows_4_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_4_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use a desktop browser and keyboard, or choose a desktop build for regular work.`)
};

const zh_gc_search_guides_gridcraft_online_sections_3_table_rows_4_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_4_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用桌面浏览器和键盘，日常工作也可以选择桌面版本。`)
};

/**
* | output |
* | --- |
* | "Use a desktop browser and keyboard, or choose a desktop build for regular work." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_4_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_3_table_rows_4_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_4_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_4_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_3_table_rows_4_1(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_3_table_rows_4_1(inputs)
});
export { gc_search_guides_gridcraft_online_sections_3_table_rows_4_1 as "gc.search_guides.gridcraft_online.sections.3.table.rows.4.1" }